import ReportStudySetup2 from './reportStudySetup2'
export default ReportStudySetup2
